module.exports = "<div class=\"igo-mini-basemap-container\">\r\n\r\n  <div *ngIf=\"display\" (click)=\"changeBaseLayer(baseLayer)\">\r\n    <igo-map-browser [map]=\"basemap\"></igo-map-browser>\r\n    <div class='igo-mini-basemap-title'>{{baseLayer.title}}</div>\r\n  </div>\r\n\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/lib/map/baselayers-switcher/mini-basemap.component.html
// module id = 951
// module chunks = 0